import { useFlags } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";

import { useAppSelector } from "app/hooks";
import { GUIDED_TOUR_FEATURE } from "constants/feature-flags";
import {
  selectCurrentClinic,
  selectCurrentUser
} from "features/auth/auth-slice";
import { viteEnv } from "utils/vite-env.util";

declare const Supademo: any;

export default function useSupademo() {
  const flags = useFlags();
  const guidedTourEnabled = flags[GUIDED_TOUR_FEATURE];
  const currentUser = useAppSelector(selectCurrentUser);
  const currentClinic = useAppSelector(selectCurrentClinic);

  return useMemo(() => {
    if (guidedTourEnabled && Boolean(Supademo)) {
      return Supademo(viteEnv.VITE_SUPADEMO_API_KEY, {
        variables: {
          email: currentUser?.email,
          name: currentUser?.full_name,
          practice_id: currentClinic?.practice?.id,
          practice_name: currentClinic?.practice?.name,
          clinic_id: currentClinic?.id,
          clinic_name: currentClinic?.name
        }
      });
    }
    return null;
  }, [
    guidedTourEnabled,
    currentUser?.email,
    currentUser?.full_name,
    currentClinic?.practice?.id,
    currentClinic?.practice?.name,
    currentClinic?.id,
    currentClinic?.name
  ]);
}
